import { render } from "./modal.vue?vue&type=template&id=1c940fe8&scoped=true&ts=true"
import script from "./modal.vue?vue&type=script&lang=ts"
export * from "./modal.vue?vue&type=script&lang=ts"

import "./modal.vue?vue&type=style&index=0&id=1c940fe8&lang=css&scoped=true"

import exportComponent from "C:\\Softwares\\vscode\\workspace\\vue-bs-modal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c940fe8"]])

export default __exports__